export const WAF_CHECK_PATH_NAME = 'waf-check';
